module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/31f212395be821de9307a65cb55829cc.png";